<template>
    <div>
	</div>
</template>

<script>
	import PaymentIntegrationItem from "@shared/Billing/PaymentIntegrationItem";
	import IntegrationStatus from "@shared/Billing/IntegrationStatus";
	import BaseComponent from "@/core/components/BaseComponent.vue";

	export default {
		extends: BaseComponent,
        name: "BasePaymentIntegrationView",
		components: {},
		props:{
        	paymentIntegrationItem: PaymentIntegrationItem
		},
		watch:{
			paymentIntegrationItem: {
				immediate: true,
				handler(newVal, oldVal) {
					this.paymentIntegrationItemData = newVal || this.createPaymentIntegrationItem()
				},
			},
		},
		data: () => ({
			paymentIntegrationItemData: null
		}),
		methods:{

			createPaymentIntegrationItem(){
				throw new Error("Not implemented")
			},
			onBackClicked(){
				let _ = this.$analyticManager.trackEvent("Payment integration back clicked", this.analyticsPropsMethod())
				this.$emit("onBackClicked")
			},
        	async onConnectPressed(){
				let _ = this.$analyticManager.trackEvent("Payment connect clicked", this.analyticsPropsMethod())

				try{
        			await this.submitFormPromise()
					let isValid = await this.progressBlocking("Validating the integration...")
						.for(_ => this.validateIntegration(this.paymentIntegrationItemData))
					if(isValid){
						let _ = this.$analyticManager.trackEvent("Integration success", this.analyticsPropsMethod())
						this.save(this.paymentIntegrationItemData)
						return true
					} else {
						this.showInvalidIntegrationError()
					}
				} catch(error){
					this.showInvalidIntegrationError(error)
				}
			},
			async validateIntegration(paymentIntegration){
				return true
			},
			showInvalidIntegrationError(error){
        		this.handleError(error, "Integration failed: please check the entered values and try again.", 5000)
			},

			save(paymentIntegrationItem){
				paymentIntegrationItem.integrationStatus = IntegrationStatus.INTEGRATED
        		this.$emit("onSave", paymentIntegrationItem)
			}

		}
	}
</script>

<style>

</style>
